export default "__VITE_ASSET__DD30KNcF__"